export default {
    methods : {
      invalidateCPSSaveState(){
          this.$store.commit('setCAPSSaveValidatedState', false);
      }
    },
    mounted(){
        this.invalidateCPSSaveState();
    },
    destroyed() {
        this.invalidateCPSSaveState();
    }
}